import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppService } from './app.service';

@Injectable({ providedIn: 'root' })
export class BrowserCheckService {

    constructor(
        private _appService: AppService,
    ) {}

    private getUserAgent(): string {
        return navigator.userAgent;
    }

    getBrowserInfo() {
        const ua = this.getUserAgent();

        // Chrome (exclut Edge et Opera)
        const chromeMatch = ua.match(/Chrome\/(\d+)/);
        const edgeMatch = ua.match(/Edg\/(\d+)/);

        if (edgeMatch) {
            return { browser: 'edge', version: parseInt(edgeMatch[1], 10) };
        }

        if (chromeMatch && !ua.includes('Edg') && !ua.includes('OPR')) {
            return { browser: 'chrome', version: parseInt(chromeMatch[1], 10) };
        }

        if (ua.includes('AppleWebKit')) {
            return { browser: 'applewebkit', version: 80 };
        }

        return { browser: ua, version: 0 };
    }

    isAllowed(minVersion = 80): boolean {
        const info = this.getBrowserInfo();
        
        if (['development', 'preprod'].includes(this._appService.appVersion$.value.APP_ENVIRONMENT.toLocaleLowerCase())) {
            return true;
        }

        if (info.browser === 'chrome' && info.version >= minVersion) return true;
        if (info.browser === 'edge' && info.version >= minVersion) return true;
        if (info.browser === 'applewebkit' && info.version >= minVersion) return true;

        return false;
    }
}
